<template>
  <section class="section introduction">
    <div class="container has-text-centered">
      <img id="earth_art" src="static/icons/earth-logo.png">
      <h1 class="title" id="home">Earth</h1>
      <h2 class="subtitle" id ="home">A Earth é um bot multi-funcional de alta qualidade.</h2>
        <p>
          <ul>
            <li>Desenvolvida com intuito de atender todas as necessidades e problemas do seu servidor.</li>
            </ul>
          </p>
          <br>
         <p>
        <ul>
            <li><span class="teste">Para ver mais informações sobre os <a href="#features">recursos</a> da Earth, consulte a página de <a href="/commands">comandos</a>.</span></li>
           <br>
          </ul>
         </p>
         <br>
        <br>
        <br>
        <br>
          <div class="buttons">
        <a class="button is-large is-primary" v-on:click="invite" target="_blank">
          <span>Convite</span>
        </a>
        <a class="button is-large is-primary" v-on:click="support" target="_blank">
          <span>Suporte</span>
        </a>
       </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    
  </section>
</template>

<script>
import { InfoIcon } from 'vue-feather-icons'

export default {
  name: 'Home',
  head: { title: { inner: 'Início' } },
  components: {
    InfoIcon
  },
  methods: {
    
    invite() {
      this.$api.openInvite();
    },

    support() {
      this.$api.openSupport()
    }
  },
    data () {
    return {
      crate: ""
    };
  },
  mounted () {
    this.$loadScript("https://cdn.jsdelivr.net/npm/@widgetbot/crate@3")
      .then(() => {
        // eslint-disable-next-line no-undef
        this.crate = new Crate({
            server: '709513808032563312',
            channel: '727724091368407060',
            color: '#182742'
           // shard: 'https://disweb.dashflo.net'
        })
      })
      
      .catch(() => {
      // Failed to fetch script
      })
  },
  destroyed () {
    this.crate.hide();
  },
}
</script>

<style scoped>
.is-centered {
  text-align: center;
}
.logo {
  animation: pulse 5s ease-in-out infinite;
  padding-bottom: 10px;
}

#earth_art {
  float: left;
  margin-right: 25px;
	border-radius: 10px;
	box-shadow: 2px 2px 10px #111;
}

#hero {
  float: left;
  margin-right: 25px;
	border-radius: 10px;
	box-shadow: 2px 2px 10px #111;
}
.stat {
  vertical-align: middle;
  margin: 0 3px;
	display: inline-block;
}
.stat > .stat-num {
  background-color: #ffffff;
  padding: 2px 4px 4px 5px;
  height: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.stat > .stat-label {
  background-color: #4884e5;
  padding: 2px 6px 4px 2px;
	border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.button {
  transition: 0.25s all ease-in-out;
  width:200px;
  height: 38px;
  box-shadow: 2px 2px 10px #111;

}
.section.thin + hr {
    margin-top: 0;
}


#features {
  text-align: center;
}

li, span, #home {
  text-align: left;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.05);
  }

  100% {
    -webkit-transform: scale(1);
  }
}

@-moz-keyframes pulse {
  0% {
    -moz-transform: scale(1);
  }

  50% {
    -moz-transform: scale(1.05);
  }

  100% {
    -moz-transform: scale(1);
  }
}
</style>
